import { Pipe, PipeTransform } from '@angular/core';
import uniqBy from 'lodash/uniqBy';

// NOTE: Do NOT use this pipe for long lists as the performance hit will be significant
@Pipe({ name: 'unique' })
export class UniquePipe implements PipeTransform {
  public transform(collection, property) {
    return uniqBy(collection, property);
  }
}
